import React from "react";
import { Route } from "react-router";
import { Navigate, Routes } from "react-router-dom";

import Header from "../management/Header";
import SideBar from "../../common/management/sidebar/SideBar";
import RequireAuth from "../../common/routing/RequireAuth";

import styles from "../management/ManagementOutline.module.scss";
import StudentListContainer from "../management-jikei/db-list/StudentListContainer";
import ReleaseList from "./release-list/ReleaseList";
import AdminDashboardOffer from "../management/offer/AdminDashboardOffer";
import ManagementPageContainer from "../../common/management/ManagementPageContainer";
import ManagerListContainer from "./manager-list/ManagerListContainer";
import JikeiTeamListContainer from "./db-list/JikeiTeamListContainer";
import SchoolListContainer from "./school-list/SchoolListContainer";
import ProjectListContainer from "../../common/management/project/ProjectListContainer";
import { ReleasePersonPreviewContainer } from "../../common/management/release/ReleasePersonPreviewContainer";
import { ReleaseTeamPreviewContainer } from "../../common/management/release/ReleaseTeamPreviewContainer";
import ReleaseProjectListContainer from "../management/release/ReleaseProjectListContainer";
import { ReleaseProjectPreviewContainer } from "../../common/management/release/ReleaseProjectPreviewContainer";
import ApplicationListContainer from "../management/application/ApplicationListContainer";
import ProjectApplicationDetailContainer from "../management/project/application/ProjectApplicationDetailContainer";
import PortfolioListContainer from "./db-list/PortfolioListContainer";
import JikeiPortfolioDetailContainer from "./db-list/detail/JikeiPortfolioDetailContainer";
import UserOverviewContainer from "../management/user/UserOverviewContainer";
import CourseListContainer from "./course-list/CourseListContainer";
import JikeiTeamDetailContainer from "./db-list/detail/JikeiTeamDetailContainer";
import { ReleaseEventListContainer } from "../management/release/ReleaseEventListContainer";
import ReleaseEventPreviewContainer from "../../common/management/release/ReleaseEventPreviewContainer";
import EventListContainer from "../management/event/EventListContainer";
import OfferListContainer from "../management/offer/OfferListContainer";
import ProjectDetailContainer from "../management/db-list/detail/ProjectDetailContainer";
import EventDetailContainer from "../management/db-list/detail/EventDetailContainer";
import { useMetaData } from "../../utils/useMetaData";

const ManagementJikei: React.FC = () => {
  useMetaData({ title: "管理画面", description: "", imgUrl: "" });

  return (
    <React.Fragment>
      <Header />
      <div className={styles["p-management"]}>
        <SideBar />

        <Routes>
          <Route
            path="student"
            element={
              <ManagementPageContainer
                key={"student"}
                apiComponent={StudentListContainer}
              />
            }
          />

          <Route
            path="student/:id"
            element={
              <UserOverviewContainer isSelect={false} pageTitle="学生詳細" />
            }
          />

          <Route
            path="portfolio"
            element={
              <ManagementPageContainer
                key={"portfolio"}
                apiComponent={PortfolioListContainer}
              />
            }
          />
          <Route
            path="portfolio/:id"
            element={<JikeiPortfolioDetailContainer />}
          />
          <Route
            path="team"
            element={
              <ManagementPageContainer
                key={"team"}
                apiComponent={JikeiTeamListContainer}
              />
            }
          />
          <Route path="team/:id" element={<JikeiTeamDetailContainer />} />

          <Route
            path="release"
            element={
              <ManagementPageContainer
                key={"release"}
                apiComponent={ReleaseList}
              />
            }
          />
          <Route
            path="release/person/:id"
            element={<ReleasePersonPreviewContainer isSelect={false} />}
          />
          <Route
            path="release/team/:id"
            element={<ReleaseTeamPreviewContainer isSelect={false} />}
          />

          <Route
            path="offer"
            element={
              <ManagementPageContainer
                key={"offer"}
                apiComponent={(props) => (
                  <OfferListContainer isSelect={false} {...props} />
                )}
              />
            }
          />
          <Route
            path="offer/:id"
            element={<AdminDashboardOffer isSelect={false} />}
          />

          <Route
            path="event"
            element={
              <ManagementPageContainer
                key={"event"}
                apiComponent={(props) => (
                  <EventListContainer isSelect={false} {...props} />
                )}
              />
            }
          />

          <Route
            path="event/release"
            element={
              <ManagementPageContainer
                key={"event-release"}
                apiComponent={(props) => (
                  <ReleaseEventListContainer isSelect={false} {...props} />
                )}
              />
            }
          />

          <Route
            path="event/release/:id"
            element={<ReleaseEventPreviewContainer isSelect={false} />}
          />

          <Route
            path="event/:id"
            element={<EventDetailContainer isSelect={false} />}
          />

          <Route
            path="school"
            element={
              <RequireAuth
                component={() => (
                  <ManagementPageContainer
                    key={"school"}
                    apiComponent={SchoolListContainer}
                  />
                )}
                role={"jikei_admin"}
              />
            }
          />

          <Route
            path="course"
            element={
              <RequireAuth
                component={() => (
                  <ManagementPageContainer
                    key={"course"}
                    apiComponent={CourseListContainer}
                  />
                )}
                role={"jikei_admin"}
              />
            }
          />

          <Route
            path="project"
            element={
              <ManagementPageContainer
                key={"project"}
                apiComponent={(props) => (
                  <ProjectListContainer isSelect={false} {...props} />
                )}
              />
            }
          />

          <Route
            path="project/release"
            element={
              <ManagementPageContainer
                key={"project-release"}
                apiComponent={(props) => (
                  <ReleaseProjectListContainer isSelect={false} {...props} />
                )}
              />
            }
          />
          <Route
            path="project/release/:id"
            element={<ReleaseProjectPreviewContainer isSelect={false} />}
          />

          <Route
            path="project/application"
            element={
              <ManagementPageContainer
                key={"application"}
                apiComponent={(props) => (
                  <ApplicationListContainer isSelect={false} {...props} />
                )}
              />
            }
          />
          <Route
            path="project/application/:id"
            element={<ProjectApplicationDetailContainer isSelect={false} />}
          />

          <Route
            path="project/:id"
            element={<ProjectDetailContainer isSelect={false} />}
          />

          <Route
            path="manager"
            element={
              <RequireAuth
                component={() => (
                  <ManagementPageContainer
                    key={"manager"}
                    apiComponent={ManagerListContainer}
                  />
                )}
                role={"jikei_admin"}
              />
            }
          />

          <Route
            path="manager/:id"
            element={
              <RequireAuth
                component={() => (
                  <UserOverviewContainer
                    isSelect={false}
                    pageTitle="管理者詳細"
                  />
                )}
                role={["jikei_admin", "jikei_manager"]}
              />
            }
          />

          <Route path="*" element={<Navigate to="student" replace />} />
        </Routes>
      </div>
    </React.Fragment>
  );
};

export default ManagementJikei;
